<template>
  <div v-on-clickaway="away" :class="conatiner_class" style="z-index: 9999;position: relative;">
    <loading
      :active="loading"
      :can-cancel="false"
      loader="dots"
      color="#2292ef"
      :is-full-page="true"
    ></loading>
    <div v-if="close && !child" @click.prevent="open" class="list-group">
      <a :style="placeholder_style" href="#" :class="placeholder_class">
        {{
        place_holder
        }}
      </a>
    </div>
    <div v-if="child" @click.prevent="close = false" class="list-group">
      <a :style="selected_style" href="#" :class="selected_class">
        {{ child.title }}
        <!-- <span style="font-size:11px;margin-left:4px;">{{ child.comment }}</span> -->
      </a>
    </div>
    <transition name="fade">
      <div v-if="!close" class="list-group">
        <loading
          :active="loading"
          :can-cancel="false"
          loader="dots"
          color="#2292ef"
          :is-full-page="true"
        ></loading>
        <a
          v-for="(parent, index) in parents"
          :key="index"
          href="#"
          @click.prevent.self="selectParent(parent.id)"
          :style="parent_item_style"
          :class="[
						parent_id == parent.id
							? parent_active_item_class
							: parent_item_class
					]"
        >
          {{ parent.title }}
          <!-- <span style="font-size:11px;margin-left:4px;"></span> -->
          <div v-if="parent_id && parent_id == parent.id" class="list-group" style="margin:0;">
            <div style="margin: 5px 0;color:#828282;">{{ text.select_a_category }}</div>
            <loading
              :active="subLoading"
              :can-cancel="false"
              loader="dots"
              color="#2292ef"
              :is-full-page="false"
            ></loading>
            <a
              v-for="(child, i) in childs"
              :key="i"
              href="#"
              :style="child_item_style"
              @click.prevent="selectChild(child)"
              :class="[
								child_id == child.id
									? child_active_item_class
									: child_item_class
							]"
            >
              {{ child.title }}
              <!-- <span style="font-size:11px;margin-left:4px;"></span> -->
            </a>
          </div>
        </a>
      </div>
    </transition>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { mixin as clickaway } from "vue-clickaway";

export default {
  name: "category-selector",
  mixins: [clickaway],
  components: {
    Loading
  },
  props: {
    place_holder: {
      type: String,
      default: "Choose a category"
    },
    category_type: {
      type: String,
      default: ""
    },
    conatiner_class: {
      type: String,
      default: ""
    },

    selected_style: {
      type: String,
      default: "border-radius: 6px;"
    },
    selected_class: {
      type: String,
      default: "list-group-item list-group-item-action"
    },
    placeholder_style: {
      type: String,
      default: "border-radius: 6px;"
    },
    placeholder_class: {
      type: String,
      default: "list-group-item list-group-item-action"
    },
    parent_item_style: {
      type: String,
      default: ""
    },
    child_item_style: {
      type: String,
      default: ""
    },
    parent_active_item_class: {
      type: String,
      default: "list-group-item list-group-item-action list-group-item-light"
    },
    parent_item_class: {
      type: String,
      default: "list-group-item list-group-item-action"
    },
    child_item_class: {
      type: String,
      default: "list-group-item list-group-item-action"
    },
    child_active_item_class: {
      type: String,
      default: "list-group-item list-group-item-action active"
    },
    value: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      parents: [],
      childs: [],
      parent_id: null,
      child_id: null,
      child: null,
      subLoading: false,
      loading: false,
      word: {},
      text: {},
      close: true
    };
  },
  created() {
    this.word = window.word;
    this.text = window.text;
    let api_token = window.api_token;
    let self = this;
    self.loading = true;
    axios({
      method: "get",
      url: "/api/v1/category/parents?category_type=" + self.category_type
    })
      .then(function(res) {
        self.loading = false;
        if (res.data.ok) {
          self.parents = res.data.data;
        }
      })
      .catch(function(err) {
        self.loading = false;
        console.log(err);
      });
  },
  methods: {
    away() {
      this.close = true;
    },
    open: function() {
      this.close = false;
    },
    removeChild: function() {
      this.child = null;
    },
    getChilds() {
      let self = this;
      self.subLoading = true;
      axios({
        method: "get",
        url:
          "/api/v1/category/childs?category_type=" +
          self.category_type +
          "&parent_id=" +
          self.parent_id
      })
        .then(function(res) {
          self.subLoading = false;
          if (res.data.ok) {
            self.childs = res.data.data;
          }
        })
        .catch(function(err) {
          self.subLoading = false;
          console.log(err);
        });
    },
    selectParent(id) {
      if (this.parent_id && this.parent_id == id) {
        this.parent_id = null;
      } else {
        this.parent_id = id;
      }
    },
    selectChild(child) {
      if (this.child_id && this.child_id == child.id) {
        this.child_id = null;
        this.child = null;
      } else {
        this.child_id = child.id;
        this.child = child;
        this.close = true;
      }
    }
  },
  watch: {
    child_id: {
      immediate: true,
      handler() {
        this.$emit("input", this.child_id);
        this.$emit("getCategory", this.child);
      }
    },
    parent_id: {
      immediate: true,
      handler() {
        if (this.parent_id != null) {
          this.$emit("parent_id", this.parent_id);
          this.getChilds();
        }
      }
    },
    value: {
      immediate: true,
      handler() {
        if (this.value != null && this.child_id == null) {
          let self = this;
          self.loading = true;
          axios({
            method: "get",
            url: "/api/v1/category/" + self.value + "/show"
          })
            .then(function(res) {
              self.loading = false;
              if (res.data.ok) {
                if (res.data.data.parent_id) {
                  self.parent_id = res.data.data.parent_id;
                  self.child_id = res.data.data.id;
                  self.child = res.data.data;
                  self.close = true;
                } else {
                  self.parent_id = res.data.data.id;
                  self.child_id = null;
                }
              }
            })
            .catch(function(err) {
              self.loading = false;
              console.log(err);
            });
        }
      }
    }
  }
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
